import React, {Component} from 'react';
import { isSimilarObject } from '../../../helper';

export default class CashOutStepFirst extends Component {

    shouldComponentUpdate(nextProps) {
        if(isSimilarObject(this.props, nextProps)) {
            return false;
        }
        return true;
    }

    getAllNumbers() {
        const {orderList} = this.props;

        if(!orderList.results || !orderList.results.length) return 'Заказов нет';

        return  <span className="chout__order-link">
                    {
                        (orderList.results || []).map((order, index) => {
                            return <a key={index} href={`/makeorder/${order.id}`} target="_blank">{order.id}</a>
                        })
                    }

                    {
                        !orderList.next ? null :
                        <a 
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                this.props.loadMoreOrders(orderList.next)
                            }}
                        >Еще</a>
                    }
                </span>
    }
    
    render() {
        const {
            fio,
            inn,
            ndfl,
            amount,
            comission,
            user_type,
            minNdflText,
            card_number,
            field_errors,
            willWithdraw,
            payment_type,
            is_email_confirmed,
            handleOnChangeSimple,
        } = this.props;
        let radioState = (user_type || false);
    
        return (
            <div style={{maxHeight: '400px',overflow: 'auto', paddingLeft: '20px', paddingRight: '20px'}}>
                <div className="chout__section chout__section-w100">
                    <input
                        disabled
                        type="text"                    
                        className="sw-alert__input"
                        value={`Сумма к выплате: ${amount} руб.`}
                        />

                    {
                        field_errors && field_errors.amount ?
                        <div className="chout__eror-field">{field_errors.amount}</div>
                        : null
                    }

                    <label className="sw-alert__label" style={{marginTop:'10px'}}>
                        За заказы: {this.getAllNumbers()}
                    </label>
                </div>

                {
                    is_email_confirmed ? null :
                    <div style={{
                        background: 'rgb(231, 76, 60)',
                        color: 'rgb(255, 255, 255)',
                        width: '80%',
                        margin: '10px auto 0 auto',
                        padding: '10px',
                    }}>Для того чтобы вывести средства подтвердите электронную почту.</div>
                }

                <div className="chout-section__border" />
                
                <div style={{display:'flex',flexDirection:'row',justifyContent: 'space-between'}}>
                    <div className="chout__section" style={{width:'46%',margin: 'unset'}}>
                        <label className="sw-alert__label">Выплату произвести на</label>
                        <select
                            value={payment_type}
                            className="sw-alert__select"
                            onChange={(e) => handleOnChangeSimple('payment_type', e.target.value)}>
                            <option value="">Не выбрано</option>
                            <option value="0">Mastercard</option>
                            <option value="1">Visa</option>
                            <option value="2">Яндекс.Деньги</option>
                        </select>

                        {
                            field_errors && field_errors.payment_type ?
                            <div className="chout__eror-field">{field_errors.payment_type}</div>
                            : null
                        }
                    </div>

                     <div className="chout__section" style={{width:'46%',margin: 'unset'}}>
                        <label className="sw-alert__label">Номер карты/кошелька</label>
                        <input
                            type="text"
                            value={card_number || ''}
                            className="sw-alert__input"
                            placeholder="Номер карты/кошелька"
                            onChange={(e) => handleOnChangeSimple('card_number', e.target.value)}
                            />

                        {
                            field_errors && field_errors.card_number ?
                            <div className="chout__eror-field">{field_errors.card_number}</div>
                            : null
                        }
                    </div>
                </div>

                <div style={{display:'flex',flexDirection:'row',justifyContent: 'space-between'}}>
                    <div className="chout__section" style={{width:'46%',margin: 'unset'}}>
                        <label className="sw-alert__label">ИНН</label>
                        <input
                            type="text"
                            value={inn || ''}
                            className="sw-alert__input"
                            placeholder="Ваш ИНН"
                            onChange={(e) => handleOnChangeSimple('inn', e.target.value)}
                            />

                        {
                            field_errors && field_errors.inn ?
                            <div className="chout__eror-field">{field_errors.inn}</div>
                            : null
                        }
                    </div>

                    <div className="chout__section" style={{width:'46%',margin: 'unset'}}>
                        <label className="sw-alert__label">ФИО</label>
                        <input
                            type="text"
                            value={fio || ''}
                            className="sw-alert__input"
                            onChange={(e) => handleOnChangeSimple('fio', e.target.value)}
                            />

                        {
                            field_errors && field_errors.fio ?
                            <div className="chout__eror-field">{field_errors.fio}</div>
                            : null
                        }
                    </div>
                </div>

                <div className="chout__section chout__section-w100" style={{flexDirection:'row',fontSize:'13px',marginTop: '8px'}}>
                    <input
                        id="chout_radio1"
                        type="radio"
                        name="chout_radio"
                        value={radioState}
                        defaultChecked={radioState}
                        onChange={(e) => handleOnChangeSimple('user_type', true)}
                        />
                    <label htmlFor="chout_radio1" className="sw-alert__label">
                        Я Индивидуальный предприниматель или самозанятый и плачу налоги самостоятельно
                    </label>
                </div>

                <div className="chout__section chout__section-w100" style={{flexDirection:'row',fontSize:'13px',marginTop: '8px'}}>
                    <input
                        id="chout_radio2"
                        type="radio"
                        name="chout_radio"
                        value={!radioState}
                        onChange={(e) => handleOnChangeSimple('user_type', false)}
                        />
                    <label htmlFor="chout_radio2" className="sw-alert__label">
                        Я не являюсь ни Индивидуальным предпринимателем ни самозанятым и прошу уплатить НДФЛ (13%) с этой выплаты
                    </label>
                </div>

                <div className="chout__section commission">
                    <span style={{display:'block'}}>Комиссия: {comission} руб.</span>
                    {
                        user_type ? null :
                        <span style={{display:'block'}}>
                            НДФЛ: {ndfl} руб. {minNdflText ? `(Минимум ${minNdflText} руб.)` : null}
                        </span>
                    }
                    {
                        user_type
                        ? <span style={{display:'block'}}>Будет выведено: {willWithdraw} руб.</span>
                        : <span style={{display:'block'}}>К выплате с учетом НДФЛ: {willWithdraw} руб.</span>
                    }
                </div>
            </div>
        )   
    }
}


// WEBPACK FOOTER //
// ./src/components/Profile/Balance/CashOutStepFirst.js